import React, { Component } from 'react';
import { ErrorBox } from '../components/ErrorBox.tsx';
import { PreviousButton } from '../components/PreviousButton.tsx';
import { NextButton } from '../components/NextButton.tsx';
import { LenderRow } from '../components/LenderRow';
import { NumberInput } from '../components/NumberInput.tsx';
import { TextInput } from '../components/TextInput.tsx';

interface IProps {
    gtmEvent(): void;
    prevStep(): void;
    nextStep(): void;
    applicant?: number;
    lvemploymenttype?: string;
    updateLead(props: any): void;
    consent: boolean; 
    applicationType: string;
    lvfulltimepermanent?:string;
    lvprobationpassed?:string;
    lvhowlongtrading?:string;
    lvovertime?:number;
    lvshiftallowance?:number;
    lvbonus?:number;
}

interface IState {
    hasError: boolean;
    errors?: string[];
    lvemploymenttype?: string;
    partnerSmoker?: boolean;    
    lvfulltimepermanent?:string;
    lvprobationpassed?:string;
    lvhowlongtrading?:string;
    lvovertime?:number;
    lvshiftallowance?:number;
    lvbonus?:number;
}

export class LVEmploymentDetails extends Component<IProps, IState> {
    
    constructor (props: IProps) {
        super(props);
        this.state = {
            hasError: false, 
            lvemploymenttype: this.props.lvemploymenttype,            
            lvfulltimepermanent: this.props.lvfulltimepermanent,
            lvprobationpassed: this.props.lvprobationpassed
        };
    }

    componentDidMount(): void {
        this.props.gtmEvent();
    }

    CaptureFullTime(option:string){
        this.setState({lvfulltimepermanent:option, hasError:false});
        this.props.updateLead({lvfulltimepermanent:option});
    }

    CaptureProbationPassed(option:string){
        this.setState({lvprobationpassed:option, hasError:false});
        this.props.updateLead({lvprobationpassed:option});
    }

    nextStep() {
    const errors: string[] = [];    

    if(this.state.lvemploymenttype=="paye" && (!this.state.lvfulltimepermanent)){
        errors.push('Full time permanent is required');        
    }

    if(this.state.lvemploymenttype=="paye" && (!this.state.lvprobationpassed)){
        errors.push('Probation passed is required');        
    }

    if(this.state.lvemploymenttype=="selfemployed" && (!this.state.lvhowlongtrading)){
        errors.push('How long trading is required');        
    }

    if (errors.length > 0) {
        this.setState({ hasError: true, errors });
        return;
    }

    this.setState({ hasError: false, errors: [] });
    this.props.nextStep()
    }
    
    render() {
        const{lvemploymenttype,lvfulltimepermanent,lvprobationpassed,hasError,errors}=this.state;       
        return (            
            <header className="App-header">
                <div className='wrapper'>
                    <h1 className='l'>Employment Details{(this.props.applicationType === 'joint' && this.props.applicant === 2)?' your partner':''}</h1>                    
                    {this.props.lvemploymenttype === 'paye' && (<>
                    <h2 className='l'> <br/>Full Time Permanent  <span className='doddltext'>?</span></h2>
                        <div className='row'>
                            <div className='column2 justify-e'>
                                <div className={`boxty mini ${lvfulltimepermanent === 'yes' ? 'selected' : ''}`} onClick={() => this.CaptureFullTime('yes')}>
                                    <div><h2 className='btn'>Yes</h2></div>
                                </div>
                            </div>

                            <div className='column2 justify-s'>
                                <div className={`boxty mini ${lvfulltimepermanent === 'no' ? 'selected' : ''}`} onClick={() => this.CaptureFullTime('no')}>
                                    <div><h2 className='btn'>No</h2></div>
                                </div>
                            </div>
                        </div>
                    <br/>
                    
                    <h2 className='l'> <span className='doddltext'>Probation Passed?</span></h2>
                        <div className='row'>
                            <div className='column2 justify-e'>
                                <div className={`boxty mini ${lvprobationpassed === 'yes' ? 'selected' : ''}`} onClick={() => this.CaptureProbationPassed('yes')}>
                                    <div><h2 className='btn'>Yes</h2></div>
                                </div>
                            </div>

                            <div className='column2 justify-s'>
                                <div className={`boxty mini ${lvprobationpassed === 'no' ? 'selected' : ''}`} onClick={() => this.CaptureProbationPassed('no')}>
                                    <div><h2 className='btn'>No</h2></div>
                                </div>
                            </div>
                        </div>
                        
                        <div className='column2 justify-e'>
                            <NumberInput
                                id='lvovertime'
                                key='lvovertime'
                                label={<>Overtime</>}
                                value={this.props.lvovertime}
                                classes={this.state.hasError && !this.state.lvovertime ? "e" : ""}
                                onChange={(e) => { this.setState({lvovertime: e.target.value}); this.props.updateLead({lvovertime:e.target.value}); }} />
                        </div>
                        <div className='column2 justify-s'>
                            <NumberInput
                                id='lvbonus'
                                key='lvbonus'
                                label={<>Bonus</>}
                                value={this.props.lvbonus}
                                classes={this.state.hasError && !this.state.lvbonus ? "e" : ""}
                                onChange={(e) => { this.setState({lvbonus: e.target.value}); this.props.updateLead({lvbonus:e.target.value}); }} />
                        </div>
                        <div className='column2 justify-s'></div><div className='column2 justify-s'></div>
                        <div className='column2 justify-s'>
                            <NumberInput
                                id='lvshiftallowance'
                                key='lvshiftallowance'
                                label={<>Shift Allowance</>}
                                value={this.props.lvshiftallowance}
                                classes={this.state.hasError && !this.state.lvshiftallowance ? "e" : ""}
                                onChange={(e) => { this.setState({lvshiftallowance: e.target.value}); this.props.updateLead({lvshiftallowance:e.target.value}); }} />
                        </div>
                        
                        </>)}
                    {this.props.lvemploymenttype === 'selfemployed' && (<>
                    {/* <h2 className='l'><span className='doddltext'>How long trading?</span></h2>                         */}
                            
                            <div className='row'>
                            <div className='column2 justify-c'>
                            <TextInput
                                id='lvhowlongtrading'
                                value={this.props.lvhowlongtrading}
                                placeholder='How long trading (years)'
                                classes={this.state.hasError && !this.state.lvhowlongtrading ? "e" : ""}
                                onChange={(e) => { this.setState({lvhowlongtrading: e.target.value}); this.props.updateLead({lvhowlongtrading:e.target.value}); }} />
                            </div>                        
                        </div> </>)}
                    

                    {hasError &&
                        <ErrorBox errors={errors!} />
                    }

                    <div className='row'>
                        <div className='button-group'>
                            <PreviousButton onClick={() => this.props.prevStep()} />
                            <NextButton customLabel='Next' onClick={() => this.nextStep()} />
                        </div>
                    </div>
                    <div className='row mt-2'>
                        <LenderRow />
                    </div> 
                    
                </div>
            </header>
        );
    }
}